'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue',
    sans-serif;
`;

export const KeyEditor = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue',
    sans-serif;
`;
